import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiInstagram, FiTwitter, FiFacebook, FiMail } from 'react-icons/fi';

const Footer = () => (
  <footer className="bg-stone-950 text-stone-400 py-12 md:py-16">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-4 gap-12 mb-12 border-b border-stone-800 pb-12">
        <div className="md:col-span-2">
          <h3 className="font-serif text-2xl text-white font-bold mb-4">The Silence Language</h3>
          <p className="max-w-md mb-6 leading-relaxed">
            Decoding the unspoken language of love. A guide by Andrei Marius Ciomîrtan to discovering the romance hidden in everyday life.
          </p>
          <div className="flex space-x-4">
            {[FiInstagram, FiTwitter, FiFacebook].map((Icon, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-full bg-stone-900 flex items-center justify-center hover:bg-brand-600 hover:text-white transition-colors">
                <SafeIcon icon={Icon} />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">Explore</h4>
          <ul className="space-y-3">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/about-book" className="hover:text-white transition-colors">About the Book</Link></li>
            <li><Link to="/read-excerpt" className="hover:text-white transition-colors">Read Excerpt</Link></li>
            <li><Link to="/author" className="hover:text-white transition-colors">About Andrei</Link></li>
            <li><Link to="/blog" className="hover:text-white transition-colors">The Love Journal</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 uppercase tracking-wider text-sm">Get the Book</h4>
          <ul className="space-y-3">
            <li><a href="https://www.amazon.com/dp/B0GHP512XW" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Kindle eBook — $5.99</a></li>
            <li><a href="https://www.amazon.com/dp/B0GVDP43BB" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Hardcover — $20.99</a></li>
            <li><a href="https://www.amazon.com/dp/B0GVDV8DQ8" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Paperback — $13.99</a></li>
          </ul>
          <div className="mt-6">
            <a href="mailto:hello@example.com" className="flex items-center space-x-2 hover:text-white transition-colors">
              <SafeIcon icon={FiMail} />
              <span>Contact Author</span>
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-center text-sm">
        <p>&copy; {new Date().getFullYear()} Andrei Marius Ciomîrtan. All rights reserved.</p>
        <div className="flex space-x-4 mt-4 md:mt-0">
          <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
          <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;